import Box from './box.vue';
export default Box;


// WEBPACK FOOTER //
// ./src/components/box/index.js